<div class="card-body">
    <div id="zoomable-timeseries-chart"></div>
</div>